import {
  EventItemType,
  eventItemTypeToStringMap,
  Vertical,
  verticalToStringMap,
} from "@/models/event-item";
import { useEffect, useState } from "react";
import Button from "../Button/Button";

type ScheduleFilterProps = {
  selectedVertical: Vertical[];
  selectedEventType: EventItemType;
  selectedMySchedule: boolean;
  shouldShowApplyButton: boolean;
  setSelectedVertical: (vertical: Vertical[]) => void;
  setSelectedEventType: (eventType: EventItemType) => void;
  setSelectedMySchedule: (selectedMySchedule: boolean) => void;
  onApply?: () => void;
};

export default function ScheduleFilter({
  selectedVertical,
  selectedEventType,
  selectedMySchedule,
  setSelectedVertical,
  setSelectedEventType,
  setSelectedMySchedule,
  shouldShowApplyButton,
  onApply,
}: ScheduleFilterProps) {
  const [localSelectedVertical, setLocalSelectedVertical] =
    useState<Vertical[]>(selectedVertical);
  const [localSelectedMySchedule, setLocalSelectedMySchedule] =
    useState<boolean>(selectedMySchedule);
  const [localSelectedEventType, setLocalSelectedEventType] =
    useState<EventItemType>(selectedEventType);

  const [isClearEnabled, setIsClearEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (localSelectedVertical.length > 0 || localSelectedMySchedule) {
      setIsClearEnabled(true);
    } else {
      setIsClearEnabled(false);
    }
  }, [
    selectedVertical,
    localSelectedVertical,
    selectedMySchedule,
    localSelectedMySchedule,
  ]);

  return (
    <div className="sm:w-full md:w-[240px] md:h-auto sm:h-full md:mx-8  md:self-start bg-[var(--Schemes-On-Error-Container)] md:bg-[var(--Neutrals-Card-Background)] sm:rounded-[1.25rem]">
      {/*
                pass array of verticals and event types to the filter component
                */}

      <div className="md:py-8 md:px-10 py-4 px-6">
        <div className="flex justify-between">
          <span className="font-semibold text-base">Filter By Schedule</span>
          {}
        </div>
        {/* Checkbox for my schedule */}
        <div className="flex items-center mt-4">
          <input
            checked={localSelectedMySchedule}
            type="checkbox"
            id="mySchedule"
            name="mySchedule"
            onClick={() => {
              setLocalSelectedMySchedule(!localSelectedMySchedule);

              if (!shouldShowApplyButton) {
                setSelectedMySchedule(!localSelectedMySchedule);
              }
            }}
          />
          <label htmlFor="mySchedule" className="ml-2 text-sm font-medium">
            My Schedule
          </label>
        </div>

        {/* filter by  vertical */}

        <div className="mt-8">
          <span className="font-semibold text-base">Filter By Vertical</span>

          <div className="flex flex-wrap gap-x-7 sm:block">
            {verticalToStringMap &&
              Object.keys(verticalToStringMap).map((key) => (
                <div key={key} className="flex items-center mt-4">
                  <input
                    checked={localSelectedVertical.includes(
                      verticalToStringMap[key] as Vertical
                    )}
                    type="checkbox"
                    id={key}
                    name={key}
                    onClick={() => {
                      // find the value of the selected vertical if there is any
                      const vertical = verticalToStringMap[key] as Vertical;
                      // if the vertical is already selected, remove it from the array
                      let temp = [];
                      if (localSelectedVertical.includes(vertical)) {
                        temp = localSelectedVertical.filter(
                          (v) => v !== vertical
                        );
                      } else {
                        // if the vertical is not selected, add it to the array
                        temp = [...localSelectedVertical, vertical];
                      }

                      setLocalSelectedVertical(temp);
                      if (!shouldShowApplyButton) {
                        setSelectedVertical(temp);
                      }
                    }}
                  />
                  <label htmlFor={key} className="ml-2 text-sm font-medium">
                    {key}
                  </label>
                </div>
              ))}
          </div>
        </div>

        {/* filter by type */}
        <div className="my-8">
          <span className="font-semibold text-base">Filter By Event Type</span>
          {eventItemTypeToStringMap &&
            Object.keys(eventItemTypeToStringMap).map((key) => (
              <div key={key} className="flex items-center mt-4">
                <input type="checkbox" id={key} name={key} />
                <label htmlFor={key} className="ml-2 text-sm font-medium">
                  {key} Capital
                </label>
              </div>
            ))}
        </div>
      </div>
      <div className="sm:hidden block border-t-[1px] border-solid border-[var(--Neutrals-Gray-1)] w-full h-1"></div>
      {shouldShowApplyButton && (
        <div className="flex justify-between py-4 px-6 items-center">
          <span
            onClick={() => {
              if (isClearEnabled) {
                setLocalSelectedVertical([]);
                setLocalSelectedMySchedule(false);

                setSelectedVertical([]);
                setSelectedMySchedule(false);
              }
            }}
            className={`text-[0.875rem] font-semibold ${
              isClearEnabled ? "cursor-pointer" : ""
            } ${
              isClearEnabled
                ? "text-[var(--Neutrals-Main-Neutral---Limed-Spruce)]"
                : "text-[var(--Neutrals-Gray-4)]"
            } `}
          >
            Clear
          </span>

          {/* Replace this button with the button component */}

          <Button
            label={`${isClearEnabled ? "Apply" : "show all items"}`}
            width="auto"
            onClick={() => {
              setSelectedVertical(localSelectedVertical);

              setSelectedMySchedule(localSelectedMySchedule);
              if (onApply) {
                onApply();
              }
            }}
            disabled={false}
          />
        </div>
      )}
    </div>
  );
}
